import type { MotionProps, Transition } from 'framer-motion';
import type { Side } from './types';

export const transition: Transition = {
  delay: 0,
  type: 'spring',
  stiffness: 500,
  damping: 40,
};

const getAxisValue = (axis: 'x' | 'y', value: number, direction: Side): number => {
  if (axis === 'x' && ['top', 'bottom'].includes(direction)) {
    return 0;
  }
  if (axis === 'y' && ['left', 'right'].includes(direction)) {
    return 0;
  }
  if (['left', 'top'].includes(direction)) return -value;
  return value;
};

export const fade = (enter: Side, out: Side, value = 10): MotionProps => {
  const initial = {
    opacity: 0,
    // height: 0,
    x: getAxisValue('x', value, enter),
    y: getAxisValue('y', value, enter),
  };

  const animate = {
    opacity: 1,
    // height: 'auto',
    x: 0,
    y: 0,
  };

  const exit = {
    opacity: 0,
    // height: 0,
    x: getAxisValue('x', value, out),
    y: getAxisValue('y', value, out),
  };

  return {
    initial,
    animate,
    exit,
  };
};
